'use strict';

module.exports = ['$translate', function ($translate) {
        /*
         * Filtro di parsing customizzato per la vista di XEditable.
         * @param {type} param1
         * @param {type} param2
         * @deprecated 
         */
        return function (text, keyNotSet) {
            if (text === undefined || text === null || text === 0 || text === '' || text.length === 0)
                return $translate.instant(keyNotSet);
            else
                return text;
        };
    }
];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/filters/EmptyFieldFilter.js
// module id = 401
// module chunks = 0